import { Mapper } from '@core/model/framework/mapper';
import { inject, injectable } from 'inversify';
import { BankConnection } from '@core/model/domain/bankConnection';
import { BankConnectionDto } from '@core/service/digital-factory/bank/types/bankConnectionDto';
import { BankConnectionStateMapper } from './bankConnectionStateMapper';

@injectable()
export class BankConnectionMapper implements Mapper<BankConnection, BankConnectionDto> {
  constructor(
    @inject(BankConnectionStateMapper)
    private readonly bankConnectionStateMapper: BankConnectionStateMapper
  ) {}

  toDomain(bankConnectionDto: BankConnectionDto): BankConnection {
    return {
      connectionId: bankConnectionDto.id,
      state: this.bankConnectionStateMapper.toDomain(bankConnectionDto.state),
    };
  }
}
